import { useMutation } from '@tanstack/vue-query';
import { toast } from 'vue-sonner';
import http from '@/services/http';
import { AxiosError } from 'axios';

interface ProfileUpdateData {
  name: string;
  email: string;
}

interface PasswordUpdateData {
  current_password: string;
  password: string;
  password_confirmation: string;
}

interface DeleteAccountData {
  password: string;
}

export function useUpdateProfile() {
  return useMutation({
    mutationFn: (data: ProfileUpdateData) => {
      return http.patch('/api/profile', data);
    },
    onSuccess: () => {
      toast.success('Profile information updated successfully.');
    },
    onError: (error: unknown) => {
      if (error instanceof AxiosError && error.response?.status === 422) {
        throw error; // Re-throw to let component handle validation errors
      } else {
        toast.error('There was an error updating your profile information.');
      }
    }
  });
}

export function useUpdatePassword() {
  return useMutation({
    mutationFn: (data: PasswordUpdateData) => {
      return http.put('/api/password', data);
    },
    onSuccess: () => {
      toast.success('Password updated successfully.');
    },
    onError: (error: unknown) => {
      if (error instanceof AxiosError && error.response?.status === 422) {
        throw error; // Re-throw to let component handle validation errors
      } else {
        toast.error('There was an error updating your password.');
      }
    }
  });
}

export function useDeleteAccount() {
  return useMutation({
    mutationFn: (data: DeleteAccountData) => {
      return http.delete('/api/profile', { data });
    },
    onSuccess: () => {
      toast.success('Account deleted successfully.');
    },
    onError: (error: unknown) => {
      if (error instanceof AxiosError && error.response?.status === 422) {
        throw error; // Re-throw to let component handle validation errors
      } else {
        toast.error('There was an error deleting your account.');
      }
    }
  });
} 